import session from "../../services/session";
import swal from "sweetalert2";
import AdminApi from "../../services/api";
import CONFIG_COMPANY from "../../services/myConfig";
import Loc from "../../services/localization";

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            filter: '',
            role: '',
            model: [],
            dynamicColors: {},
            days: ['MONDAY', 'TUESDAY', 'WEDNESDAY', 'THURSDAY', 'FRIDAY', 'SATURDAY', 'SUNDAY']
        }
    },
    computed: {
        filteredTerms() {
            let _self = this;
            return this.model.filter(item => {
                let item2 = _self.convertDayToRs(item.day)
                let filterList = this.filter.split(" ");
                if(filterList.length === 1){
                    let filter1 = filterList[0];
                    return item.startAt.toLowerCase().indexOf(filter1.toLowerCase()) > -1 || item2.toLowerCase().indexOf(filter1.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(filter1.toLowerCase()) > -1
                }else if(filterList.length === 2){
                    let filter1 = filterList[0];
                    let filter2 = filterList[1];
                    return (item.startAt.toLowerCase().indexOf(filter1.toLowerCase()) > -1 || item2.toLowerCase().indexOf(filter1.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(filter1.toLowerCase()) > -1)
                            && (item.startAt.toLowerCase().indexOf(filter2.toLowerCase()) > -1 || item2.toLowerCase().indexOf(filter2.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(filter2.toLowerCase()) > -1)
                }else if(filterList.length === 3){
                    let filter1 = filterList[0];
                    let filter2 = filterList[1];
                    let filter3 = filterList[2];
                    return (item.startAt.toLowerCase().indexOf(filter1.toLowerCase()) > -1 || item2.toLowerCase().indexOf(filter1.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(filter1.toLowerCase()) > -1)
                        && (item.startAt.toLowerCase().indexOf(filter2.toLowerCase()) > -1 || item2.toLowerCase().indexOf(filter2.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(filter2.toLowerCase()) > -1)
                        && (item.startAt.toLowerCase().indexOf(filter3.toLowerCase()) > -1 || item2.toLowerCase().indexOf(filter3.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(filter3.toLowerCase()) > -1)
                }else {
                    return item.startAt.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 || item2.toLowerCase().indexOf(this.filter.toLowerCase()) > -1 || item.trainingType.toLowerCase().indexOf(this.filter.toLowerCase()) > -1
                }
            })
        }
    },
    methods: {
        load: load,
        convertDayToRs: convertDayToRs,
        addTerm: addTerm,
        editTerm: editTerm,
        openTrainingTypes: openTrainingTypes,
        getBorderColorForType: getBorderColorForType,
        deleteTerm: deleteTerm,
        createSlots: createSlots,
        deleteFiltered: deleteFiltered,
        getDynamicColor: getDynamicColor,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_TRAINER') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        this.role = session.getRole();
        this.dynamicColors = session.getAppColors();
        this.filter = sessionStorage.getItem("termFilter") != null ? sessionStorage.getItem("termFilter") : "";
        this.load()
    },
    watch: {
        'filter': function (newVal) {
            sessionStorage.setItem("termFilter", newVal)
        },
    },
}

function getDynamicColor(itemId){
    if(this.dynamicColors[itemId] != null){
        return 'color: #'+ this.dynamicColors[itemId];
    }
    return '';
}

function load() {
    let _self = this;
    AdminApiService.getTerms()
        .then((response) => {
            _self.model = response.data;

        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getBorderColorForType(type) {
    const theme = getCurrentTheme();
    const palette = theme === 'light' ? TERM_SLOT_PALETTE_LIGHT : TERM_SLOT_PALETTE_DARK;
    const token = getTokenByType(type, palette);
    const borderColor = hexToRgba(token.border, theme === 'light' ? 0.58 : 0.72);
    const bgStart = hexToRgba(token.start, theme === 'light' ? 0.52 : 0.44);
    const bgEnd = hexToRgba(token.end, theme === 'light' ? 0.38 : 0.3);
    return 'border: 1px solid ' + borderColor + ';' +
        ' background: linear-gradient(135deg, ' + bgStart + ' 0%, ' + bgEnd + ' 100%);';
}

function getCurrentTheme() {
    if (typeof document === 'undefined' || document.body == null) return 'dark';
    if (document.body.classList.contains('theme-light')) return 'light';
    return 'dark';
}

function getTokenByType(type, palette) {
    const key = String(type == null ? '' : type).trim().toLowerCase();
    const hash = hashString(key.length > 0 ? key : 'default');
    const index = Math.abs(hash) % palette.length;
    return palette[index];
}

function hashString(text) {
    let hash = 0;
    for (let i = 0; i < text.length; i++) {
        hash = ((hash << 5) - hash) + text.charCodeAt(i);
        hash |= 0;
    }
    return hash;
}

function hexToRgba(hexColor, alpha) {
    const hex = normalizeHex(hexColor).replace('#', '');
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
}

function normalizeHex(color) {
    const value = String(color || '').trim().replace('#', '');
    if (value.length === 3) {
        return '#' + value[0] + value[0] + value[1] + value[1] + value[2] + value[2];
    }
    if (value.length === 6) {
        return '#' + value;
    }
    return '#7890c0';
}

const TERM_SLOT_PALETTE_DARK = [
    { start: '#4d73d1', end: '#3558ad', border: '#6f91ea' },
    { start: '#45a8a2', end: '#2f837e', border: '#63c4bd' },
    { start: '#9a66d8', end: '#7644ba', border: '#b387ea' },
    { start: '#d07b45', end: '#ad5d2c', border: '#e49c6e' },
    { start: '#6ea64f', end: '#4f7f34', border: '#8ecb6d' },
    { start: '#c75f94', end: '#9f4170', border: '#df85b1' },
    { start: '#4f9ac8', end: '#3375a2', border: '#73b8e3' },
    { start: '#c26b58', end: '#994b3a', border: '#dc8f7d' },
    { start: '#7a82d2', end: '#575fb0', border: '#9ba3ef' },
    { start: '#47a67a', end: '#2f825c', border: '#69c79b' }
];

const TERM_SLOT_PALETTE_LIGHT = [
    { start: '#cfe0ff', end: '#b9cdf9', border: '#6d8fd8' },
    { start: '#ccefeb', end: '#b6e2dd', border: '#4f9c96' },
    { start: '#e6d6ff', end: '#d7c3fb', border: '#8d67c8' },
    { start: '#ffe1cc', end: '#f8cfb3', border: '#b56f43' },
    { start: '#d9efcc', end: '#c8e3b9', border: '#69984a' },
    { start: '#ffd5e6', end: '#f5bfd8', border: '#b35e89' },
    { start: '#d3ecff', end: '#bfdef7', border: '#4d88b4' },
    { start: '#ffe0d8', end: '#f6c9bc', border: '#b26152' },
    { start: '#dddfff', end: '#cbcffa', border: '#6770c3' },
    { start: '#d2f0e3', end: '#bde4d4', border: '#4b8d6d' }
];


function addTerm() {
  this.$router.push('add-term')
}

function editTerm(term) {
    this.$router.push('edit-term?id='+term.id)
}

function deleteTerm(term) {
    let _self = this;

    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_delete_term') + ": "+convertDayToRs(term.day)+' '+term.startAt,
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        AdminApiService.deleteTerm(term.id)
            .then((response) => {
                swal(LocService.t('label_success'), LocService.t('label_term_deleted_success'), 'success')
                _self.load()
            })
            .catch((error) => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}

function createSlots() {
    this.$router.push('open-terms')
}

function convertDayToRs(day) {
    switch (day) {
        case 'MONDAY':
            return LocService.t('day_monday')
        case 'TUESDAY':
            return LocService.t('day_tuesday')
        case 'WEDNESDAY':
            return LocService.t('day_wednesday')
        case 'THURSDAY':
            return LocService.t('day_thursday')
        case 'FRIDAY':
            return LocService.t('day_friday')
        case 'SATURDAY':
            return LocService.t('day_saturday')
        case 'SUNDAY':
            return LocService.t('day_sunday')
    }
}

function deleteFiltered() {
    let _self = this;
    swal({
        title: LocService.t('label_are_you_sure'),
        text: LocService.t('label_are_you_sure_delete_found_terms'),
        type: 'warning',
        showCancelButton: true,
        cancelButtonText: LocService.t('label_no'),
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: LocService.t('label_yes'),
        customClass: 'swal2-warning'
    }).then(function () {
        let ids = _self.filteredTerms.map(x => x.id)
        AdminApiService.deleteTerms(ids)
            .then((response) => {
                swal(LocService.t('label_success'),LocService.t('label_terms_deleted_success'), 'success')
                _self.load()
                _self.filter = ""
            })
            .catch((error) => {
                swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
            })
    });
}


function openTrainingTypes(){
    this.$router.push('training-types')
}



// WEBPACK FOOTER //
// ./src/components/Term/Term.js